// Cars are tool groups of the "Car" type. ToolGroupTypes ids: 1 = Car, 2 = Tool Groups, 3 = HeavyMachinery.
export const CAR_TOOL_GROUP_TYPE_ID = 1;

// Values match the VehicleCategory, FuelType and CustomFieldType enums in ToolScanner.Domain.
export const VEHICLE_CATEGORIES = [
  { value: 1, labelKey: 'cars.categories.passengerCar' },
  { value: 2, labelKey: 'cars.categories.van' },
  { value: 3, labelKey: 'cars.categories.truck' },
  { value: 4, labelKey: 'cars.categories.bus' },
  { value: 5, labelKey: 'cars.categories.trailer' },
  { value: 6, labelKey: 'cars.categories.other' },
];

export const FUEL_TYPES = [
  { value: 1, labelKey: 'cars.fuelTypes.petrol' },
  { value: 2, labelKey: 'cars.fuelTypes.diesel' },
  { value: 3, labelKey: 'cars.fuelTypes.electric' },
  { value: 4, labelKey: 'cars.fuelTypes.petrolElectric' },
  { value: 5, labelKey: 'cars.fuelTypes.dieselElectric' },
  { value: 6, labelKey: 'cars.fuelTypes.other' },
];

export const CUSTOM_FIELD_TYPES = [
  { value: 1, labelKey: 'cars.customFieldTypes.text' },
  { value: 2, labelKey: 'cars.customFieldTypes.number' },
  { value: 3, labelKey: 'cars.customFieldTypes.date' },
  { value: 4, labelKey: 'cars.customFieldTypes.yesNo' },
];

export const CUSTOM_FIELD_TYPE = { TEXT: 1, NUMBER: 2, DATE: 3, YES_NO: 4 };

export function labelKeyFor(options, value) {
  return options.find(o => o.value === value)?.labelKey || '';
}

// "2026-06-24T00:00:00" -> "2026-06-24", the value format of the date pickers
export function toDateInput(isoDate) {
  return isoDate ? isoDate.substring(0, 10) : '';
}

export function formatDate(isoDate) {
  if (!isoDate) return '';
  const parsed = new Date(isoDate);
  if (isNaN(parsed)) return '';
  return parsed.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// A custom field's value lives in the tool group property named by field.propertyKey
export function customFieldValue(toolGroupProperties, field) {
  return (toolGroupProperties || []).find(p => p.key === field.propertyKey)?.value || '';
}
